import { useContext } from 'react';

import type { AnalyticsClient } from './analytics-client';

import { AnalyticsContext } from './internal/analytics-context';

/**
 * Returns the active `AnalyticsClient`, or `null` during SSR / outside the
 * provider. Always use optional chaining (`analytics?.track(...)`) at call
 * sites — the null case is real (SSR render before hydration, tests with
 * no provider wrapper, error boundaries, etc.).
 */
export function useAnalytics(): AnalyticsClient | null {
  return useContext(AnalyticsContext);
}
